// Brandfetch Logo Link configuration.
// Swap this for your own client ID — it is the only place it should live.
export const BRANDFETCH_CLIENT_ID = '1idJkWWI-fG-Lsuu5e7'

/**
 * Builds a Brandfetch logo URL for a company domain (e.g. "apple.com").
 * The client ID is appended here rather than being baked into stored URLs.
 */
export function getCompanyLogoUrl(domain?: string): string | undefined {
  if (!domain) return undefined
  return `https://cdn.brandfetch.io/domain/${domain}?c=${BRANDFETCH_CLIENT_ID}`
}
